import { Accordion } from '@ui-kit'
import { formatZipCode } from '../../utils/formatter'
import { STRINGS } from '../../utils/strings'

const ViewOnlyFieldLocal: React.FC<{ label: string; value: string }> = ({
  label,
  value,
}) => {
  return (
    <div className="w-full font-primary flex flex-col">
      <span className="text-xs font-extraLight">{label}</span>
      <span className="font-light text-xs">{value}</span>
    </div>
  )
}

const PatientDetails = () => {
  const data = {
    id: 1,
    first_name: 'Bill',
    last_name: 'Martin',
    dob: '03/10/1962',
    address: '1234 Main St',
    city: 'Sedona',
    state: 'Arkansas',
    zip_code: '86336',
    gender: 'Male',
    address_2: 'Apt 7700',
    prescriber_information: {
      prescriber_name: 'Dr. Jonathan Smith',
      prescriber_npi: '1234567890',
      prescriber_address: '1234 49th St',
      prescriber_address_2: 'Suite #200',
      prescriber_city: 'Scottsdale',
      prescriber_state: 'Arkansas',
      prescriber_zip_code: '86336',
    },
    drug_info: {
      drug_name: 'Tecfidera',
      drug_npc: '64406-0007-03',
      drug_indication: 'Relapsing forms of Multiple Sclerosis',
      dosage_form: 'Injectable',
    },
    diagnostic_info: {
      icd10: 'G35: Multiple Sclerosis',
    },
  }

  return (
    <div className="flex flex-col gap-4 py-2">
      <form className="flex flex-col gap-4">
        <Accordion heading="Patient Demographics" isDefaultActive={true}>
          <div className="flex flex-col gap-4 p-2">
            <div className="flex gap-4">
              <div className="flex-1">
                <ViewOnlyFieldLocal
                  label="First Name"
                  value={data.first_name}
                />
              </div>
              <div className="flex-1">
                <ViewOnlyFieldLocal label="Last Name" value={data.last_name} />
              </div>
              <div className="flex-1">
                <ViewOnlyFieldLocal label="Date of Birth" value={data.dob} />
              </div>
              <div className="flex-1">
                <ViewOnlyFieldLocal label="Gender" value={data.gender} />
              </div>
              <div className="flex-1"></div>
            </div>
            <div className="flex gap-4">
              <div className="flex-1">
                <ViewOnlyFieldLocal label="Address" value={data.address} />
              </div>
              <div className="flex-1">
                <ViewOnlyFieldLocal
                  label="Address 2 (Optional)"
                  value={data.address_2}
                />
              </div>
              <div className="flex-1">
                <ViewOnlyFieldLocal label="City" value={data.city} />
              </div>
              <div className="flex-1">
                <ViewOnlyFieldLocal label="State" value={data.state} />
              </div>
              <div className="flex-1">
                <ViewOnlyFieldLocal
                  label={STRINGS.ZIP_CODE}
                  value={formatZipCode(data.zip_code)}
                />
              </div>
            </div>
          </div>
        </Accordion>
        <Accordion heading="Prescriber Information" isDefaultActive={true}>
          <div className="flex flex-col gap-4 p-2">
            <div className="flex gap-4">
              <div className="flex-1">
                <ViewOnlyFieldLocal
                  label="Name"
                  value={data.prescriber_information.prescriber_name}
                />
              </div>
              <div className="flex-1">
                <ViewOnlyFieldLocal
                  label="NPI"
                  value={data.prescriber_information.prescriber_npi}
                />
              </div>
              <div className="flex-1"></div>
              <div className="flex-1"></div>
              <div className="flex-1"></div>
            </div>
            <div className="flex gap-4">
              <div className="flex-1">
                <ViewOnlyFieldLocal
                  label="Address"
                  value={data.prescriber_information.prescriber_address}
                />
              </div>
              <div className="flex-1">
                <ViewOnlyFieldLocal
                  label="Address 2 (Optional)"
                  value={data.prescriber_information.prescriber_address_2}
                />
              </div>
              <div className="flex-1">
                <ViewOnlyFieldLocal
                  label="City"
                  value={data.prescriber_information.prescriber_city}
                />
              </div>
              <div className="flex-1">
                <ViewOnlyFieldLocal
                  label="State"
                  value={data.prescriber_information.prescriber_state}
                />
              </div>
              <div className="flex-1">
                <ViewOnlyFieldLocal
                  label={STRINGS.ZIP_CODE}
                  value={formatZipCode(
                    data.prescriber_information.prescriber_zip_code
                  )}
                />
              </div>
            </div>
          </div>
        </Accordion>
        <Accordion heading="Prescriber Information" isDefaultActive={true}>
          <div className="flex flex-col gap-4 p-2">
            <div className="flex gap-4">
              <div className="flex-1">
                <ViewOnlyFieldLocal
                  label="Drug Name"
                  value={data.drug_info.drug_name}
                />
              </div>
              <div className="flex-1">
                <ViewOnlyFieldLocal
                  label="Drug NPC"
                  value={data.drug_info.drug_npc}
                />
              </div>
              <div className="flex-[2]">
                <ViewOnlyFieldLocal
                  label="Drug Indication"
                  value={data.drug_info.drug_indication}
                />
              </div>
              <div className="flex-1">
                <ViewOnlyFieldLocal
                  label="Dosage Form"
                  value={data.drug_info.dosage_form}
                />
              </div>
            </div>
          </div>
        </Accordion>
        <Accordion heading="Prescriber Information" isDefaultActive={true}>
          <div className="flex flex-col gap-4 p-2">
            <div className="flex gap-4">
              <div className="flex-[3]">
                <ViewOnlyFieldLocal
                  label="ICD10"
                  value={data.diagnostic_info.icd10}
                />
              </div>
              <div className="flex-[4]"></div>
            </div>
          </div>
        </Accordion>
      </form>
    </div>
  )
}

export default PatientDetails
